import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes : 0,
  message:'',
  token:null
};

const storedUser = localStorage.getItem('user');
const storedToken = localStorage.getItem('token');

if (storedUser || storedToken) {
    initialState.user = storedUser ? JSON.parse(storedUser) : null;
    initialState.token = storedToken || null;
    initialState.response = storedToken ? { data: { access_token: storedToken } } : null;
} else {
    initialState.response = null;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup : (state) => {
        state.callTimes++;
        state.error = null;
        state.message = '';
    },
    signin :(state) =>  {
        state.callTimes++;
        state.error = null;
        state.message = '';
    },
    failed: (state, {payload}) => {
        state.error = true;
        state.loading = false;
        state.message = payload.message;
    },

    success : (state, {payload})=>{
        localStorage.setItem('user', JSON.stringify(payload?.data?.name))
        localStorage.setItem('token', payload?.data?.access_token)
        state.user = payload?.data?.name ?? null;
        state.loading = false;
        state.response = payload;
        state.message = payload.message;
        state.token = payload?.data?.access_token;
        state.error = null;
    },
    logout : (state)=>{
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.user = null;
      state.response = null;
      state.token = null;
      state.error = null;
      state.loading = false;
      state.message = '';
  },
    clearStatus: (state) => {
      state.error = null;
      state.message = '';
    }
  },
})

// Action creators are generated for each case reducer function
export const { signup, signin, success, failed, logout, clearStatus } = userSlice.actions

export default userSlice.reducer
